import {
	usersService,
	rolesService,
	fichasService,
	solicitudesService,
	fileService,
	consultasService,
	constanciasService,
	configSevice,
	modulosService,
	userMicrositioService
} from './instances';

export {
	usersService,
	rolesService,
	fichasService,
	solicitudesService,
	fileService,
	consultasService,
	constanciasService,
	configSevice,
	modulosService,
	userMicrositioService
};
